'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/pro-solid-svg-icons';
import { HeatmapButton } from 'src/components/Discovery/components/HeatmapButton';
import { MAX_ZOOM, MIN_ZOOM } from 'src/components/constants';
import { useSelector, useDispatch } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { RoutesDrawerToggle } from 'src/components/Routes/panels/RoutesDrawer';
import { RoutePreviewControl } from 'src/components/Discovery/components/RoutePreviewControl';
import { selectDiscoveryMapZoom, setZoom } from 'src/redux/slices/discoveryMapSlice';

const ControlsPanel = () => {
  const ZOOM_STEP = 1.25;
  const { useWebRouting } = useFlags();
  const dispatch = useDispatch();
  const zoom = useSelector(selectDiscoveryMapZoom);

  const handleZoomIn = () => {
    if (zoom >= MAX_ZOOM) return;
    dispatch(setZoom(zoom + ZOOM_STEP));
  };

  const handleZoomOut = () => {
    if (zoom <= MIN_ZOOM) return;
    dispatch(setZoom(zoom - ZOOM_STEP));
  };

  return (
    <div className="absolute bottom-10 left-5 z-50 inline-flex flex-col justify-start items-start gap-4">
      <RoutePreviewControl />
      {useWebRouting && <RoutesDrawerToggle />}
      <HeatmapButton />
      <div className="bg-white rounded-lg shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] outline outline-1 outline-offset-[-1px] outline-neutral-300 inline-flex flex-col overflow-hidden">
        <button
          onClick={handleZoomIn}
          disabled={zoom >= MAX_ZOOM}
          className="font-semibold transition-all duration-200 select-none text-base bg-neutral-50 text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-500 disabled:bg-neutral-100 disabled:text-neutral-400 p-4 flex items-center justify-center rounded-none"
          data-testid="zoom-in-button"
        >
          <Icon icon={faPlus} className="text-neutral-600 font-bold w-4 h-4" />
        </button>
        <div className="w-full h-px px-4">
          <div className="h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
        </div>
        <button
          onClick={handleZoomOut}
          disabled={zoom <= MIN_ZOOM}
          className="font-semibold transition-all duration-200 select-none text-base bg-neutral-50 text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-500 disabled:bg-neutral-100 disabled:text-neutral-400 p-4 flex items-center justify-center rounded-none"
          data-testid="zoom-out-button"
        >
          <Icon icon={faMinus} className="text-neutral-600 font-bold w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ControlsPanel;
